import { render, staticRenderFns } from "./SugestaoDistribuicao.vue?vue&type=template&id=29c00055&scoped=true"
import script from "./SugestaoDistribuicao.vue?vue&type=script&lang=js"
export * from "./SugestaoDistribuicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c00055",
  null
  
)

export default component.exports